import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { Navbar, Sidebar, DesignSidebar } from 'src/app/components';
import LoadingSpinner from 'src/app/components/LoadingSpinner/LoadingSpinner';
import { LayoutPropsType } from 'src/app/layouts/Default/layout-default.config';

import styles from 'src/app/layouts/Default/LayoutDefault.module.scss';
import { reduxRootTypes } from 'src/types';
const CollapsedContext = createContext<
  { collapsed: boolean; setCollapsed: React.Dispatch<React.SetStateAction<boolean>> } | undefined
>(undefined);

// Use a custom hook for accessing the context
export const useCollapsedContext = () => {
  const context = useContext(CollapsedContext);
  if (!context) {
    throw new Error('useCollapsedContext must be used within a CollapsedContextProvider');
  }
  return context;
};
const LayoutDefault: React.FC<LayoutPropsType> = ({ children, excludeNavbar, excludeSidebar, excludeToolbar }) => {
  const [collapsed, setCollapsed] = useState(false);

  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const eventState = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  // Provide the context value to children
  const contextValue = { collapsed, setCollapsed };
  return (
    <CollapsedContext.Provider value={contextValue}>
      <div className={styles.layout}>
        {!excludeNavbar && <Navbar />}
        <div className={styles.contentContainer}>
          {excludeSidebar ? <DesignSidebar /> : <Sidebar />}
          <div
            className={
              !eventState.eventId && userState.isRegistered
                ? `${styles.content} ${styles.eventSelection}`
                : styles.content
            }
          >
            {children}
          </div>
        </div>
        <LoadingSpinner />
      </div>
    </CollapsedContext.Provider>
  );
};

LayoutDefault.defaultProps = {
  excludeNavbar: false,
  excludeSidebar: false,
  excludeToolbar: false,
};

export default LayoutDefault;
